export class DateConverter {
	
	static fromUTCTimeToLocalTime(timestamp) {
		let time = timestamp.slice( 0, 5 );
		let today = new Date();
		let todayString = DateConverter.getDateString(today);
		return new Date(todayString + 'T' + time + 'Z').toTimeString().slice(0,5);
	}
	
	static fromLocalTimeToUTCTime( timestamp ){
		let time = timestamp.slice( 0, 5 );
		let isoExtention = '+0000';
		let today = new Date();
		let todayString = DateConverter.getDateString(today);
		let localTimeString = todayString+ 'T' + time + DateConverter.getTimezoneString( today );
		
		return new Date(localTimeString).toISOString().slice(11,16) + isoExtention;
	}
	
	static getDateString( date ){
		let year = date.getFullYear();
		let month = date.getMonth() + 1;
		if ( month < 10 ) {
			month = '0' + month;
		}
		let day = date.getDate();
		if ( day < 10 ) {
			day = '0' + day
		}
		return year + '-' + month + '-' + day;
	}
	
	static getTimezoneString( date ) {
		let offset = date.getTimezoneOffset();
		let hours = offset / (-60);
		let isPositive = hours > 0;
		hours = Math.abs(hours);
		if ( hours < 10 ){
			hours = '0' + hours;
		}
		hours = (isPositive ? '+' : '-') + hours + ':00';
		
		return hours;
	}
}